import { getP } from 'redux-polyglot'
import { deviceNotify, DEVICE_NOTIFY_SUCCESS } from '../actions/app'
import api from '../libs/api'

/**
 * Actions for retrieving user details
 */
export const USER_DETAILS_REQUEST = 'ACCOUNT/USER/REQUEST'
export const USER_DETAILS_SUCCESS = 'ACCOUNT/USER/SUCCESS'
export const USER_DETAILS_FAILURE = 'ACCOUNT/USER/FAILURE'

export const userDetailsRequest = () => ({
  type: USER_DETAILS_REQUEST
})

const userDetailsSuccess = (userDetails) => ({
  type: USER_DETAILS_SUCCESS,
  payload: userDetails
})

const userDetailsFailure = (error) => ({
  type: USER_DETAILS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

export const getUserDetails = () => (dispatch, getState) => {
  dispatch(userDetailsRequest())
  return dispatch(deviceNotify(false)).then(notifyAction => {
    if (notifyAction.type === DEVICE_NOTIFY_SUCCESS) {
      return api.getUserDetails()
        .then(res => res.json())
        .then(
          response => {
            if (response.status === 200) {
              return dispatch(userDetailsSuccess(response.me))
            } else {
              return dispatch(userDetailsFailure(response.reason))
            }
          },
          () => dispatch(userDetailsFailure(getP(getState()).t("tv_account.error_loading_user_details", { _: "An error occurred while loading user details" })))
        )
    } else {
      return dispatch(userDetailsFailure(getP(getState()).t("tv_account.error_loading_user_details", { _: "An error occurred while loading user details" })))
    }
  })
}

/**
 * Actions for dismissing an error
 */
export const DISMISS_ERROR = 'ACCOUNT/DISMISS/ERROR'

export const dismissError = () => ({
  type: DISMISS_ERROR
})
